import React, { useState } from "react";
import { Button, Dropdown } from "react-bootstrap";
import NutrientDropdown from "../../../shared/dropdowns/NutrientDropdown";
import gettext from "../../../shared/utils/gettext";
import Icon from "../../../shared/icons/Icon";

export interface NavBarAppsAppProperties {
  gid: string;
  url: string;
  name: string;
  img: string;
}
interface NavBarAppsProperties {
  title: string;
  onClick: (id: string) => void;
  navApplicationsInstalled: Array<NavBarAppsAppProperties>;
  navApplicationsOther: Array<NavBarAppsAppProperties>;
  permission: boolean;
}

const NavBarApps = ({
  navApplicationsInstalled,
  navApplicationsOther,
  onClick,
  title,
  permission,
}: NavBarAppsProperties) => {
  const [filter, setFilter] = useState("");
  const [searchResults, setSearchResults] =
    useState<NavBarAppsAppProperties[]>(navApplicationsInstalled);
  var shuffled = navApplicationsOther.sort(() => 0.5 - Math.random());
  const [searchResultsOther, setSearchResultsOther] = useState<NavBarAppsAppProperties[]>(shuffled);
  React.useEffect(() => {
    const results = navApplicationsInstalled.filter(
      (b, name) => b.name.toLowerCase().indexOf(filter) >= 0
    );
    setSearchResults(results);
  }, [navApplicationsInstalled, filter]);
  React.useEffect(() => {
    const results = navApplicationsOther.filter(
      (b, name) => b.name.toLowerCase().indexOf(filter) >= 0
    );
    setSearchResultsOther(results);
  }, [navApplicationsOther, filter]);

  return (
    <Dropdown
      navbar={true}
      alignRight={true}
      className="c-navbar__nav-item c-navbar__nav-item--dropdown dropdown-scroll"
      as={"li"}
    >
      <Dropdown.Toggle as={"button"} bsPrefix={"apps-button c-btn c-btn--tertiary c-btn--sm"}>
        {title}
        <Icon icon={"chevron down"} size={"fa-sm"} />
      </Dropdown.Toggle>
      <NutrientDropdown.Menu>
        <NutrientDropdown.Search>
          <input
            className="form-control"
            placeholder={gettext("Search...")}
            type="search"
            onChange={(e) => setFilter(e.target.value.toLowerCase())}
            autoFocus={true}
          />
        </NutrientDropdown.Search>
        <NutrientDropdown.Header title={gettext("Installed apps")} />
        <div className={"dropdown-apps"}>
          <ul className="dropdown-menu-scrollarea">
            {searchResults.length > 0 ? (
              searchResults.map((b, index) => (
                <NutrientDropdown.appItem active key={index} href={b.url} img={b.img}>
                  {b.name}
                </NutrientDropdown.appItem>
              ))
            ) : (
              <NutrientDropdown.appItem active key={0}>
                {gettext("No search results")}
              </NutrientDropdown.appItem>
            )}
          </ul>
        </div>
        <NutrientDropdown.Header title={gettext("Available apps")} />
        <div>
          {searchResultsOther.length > 0 ? (
            searchResultsOther
              .slice(0, 3)
              .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
              .map((b, index) => (
                <NutrientDropdown.appItem
                  active
                  key={index}
                  href={"/cropr/settings/apps/#" + b.gid}
                  img={b.img}
                >
                  {b.name}
                </NutrientDropdown.appItem>
              ))
          ) : (
            <NutrientDropdown.appItem active key={0}>
              {gettext("No search results")}
            </NutrientDropdown.appItem>
          )}
        </div>
        <Button
          href={"/cropr/settings/apps/"}
          size="sm"
          variant="link"
          className="pl-4 test-all-apps"
        >
          {gettext("All available Apps")}
        </Button>
      </NutrientDropdown.Menu>
    </Dropdown>
  );
};

export default NavBarApps;
